import Vue from 'vue';
import App from '@/App.vue';
import { PiniaVuePlugin } from 'pinia';
import vuetify from '@/plugins/vuetify.js';

// Импортируем плагины
import polyfills from '@/plugins/polyfills.js';

import { plugin } from '@ifr/form-questionnaire';
Vue.use(plugin);
import { defineExcelViewer } from '@/plugins/excelViewer';

import { AxiosError, AxiosStatic } from 'axios';
import moment from 'moment';
import Uri, { uri } from '@/store/uri';

// <excel-viewer> - веб-компонент, не компонент Vue (src/plugins/excelViewer/README.md)
Vue.config.ignoredElements = ['excel-viewer'];
defineExcelViewer();
// Регистрируем плагины Vue ДО создания экземпляра приложения
Vue.use(PiniaVuePlugin);

// Создаем экземпляр Pinia
import pinia from '@/store/mainStore';

// Импортируем axios после создания pinia (если нужно)
import { axios } from '@/plugins/http-axios';
import router from '@/router';
import { useErrorStore } from '@/store/stores';
// import { useErrorStore } from '@/store/stores';

// Настраиваем прототип Vue
moment.locale('ru');
Vue.prototype.$moment = moment;
Vue.prototype.$axios = axios;
Vue.prototype.$vuetify = vuetify;
Vue.prototype.$uri = uri;

Vue.config.productionTip = false;

// Временно отключаем errorHandler и warnHandler, которые используют store
// или создаем их после инициализации приложения

// Лучше создать обертку, которая будет проверять наличие активного Pinia
Vue.config.errorHandler = function(e: any, vm, info) {
  const isAxiosError = e instanceof AxiosError;
  if (isAxiosError) {
    return;
  }

  console.error(e, info);
  try {
    // Пытаемся получить store только если Pinia активен
    const errorStore = useErrorStore();
    e.name = info + ' ' + e.name;
    errorStore.setError(e);
  } catch (piniaError) {
    // Если Pinia еще не активен, логируем в консоль
    console.error('Error (Pinia not ready):', e);
  }
};

Vue.config.warnHandler = function(msg, vm, trace) {
  try {
    const errorStore = useErrorStore();
    // @ts-ignore
    errorStore.setError(new Error(msg));
  } catch (piniaError) {
    console.error('Warning (Pinia not ready):', msg + trace);
  }
  console.error(msg + trace);
};

declare module 'vue/types/vue' {
  interface Vue {
    $axios: AxiosStatic;
    // @ts-ignore
    $moment: moment;
    $uri: Uri;
  }
}
// Создаем экземпляр приложения
new Vue({
  pinia,
  router,
  vuetify,
  beforeCreate() {
    polyfills();
    // if (process.env.VUE_APP_MOCK === 'true') mock();
  },
  render: (h) => h(App),
}).$mount('#app');
